import {
  RESET_FAQ_MESSAGE,
  GET_FAQ,
  GET_FAQ_SUCCESS,
  GET_FAQ_FAIL,
  ADD_FAQ,
  ADD_FAQ_SUCCESS,
  ADD_FAQ_FAIL,
  UPDATE_FAQ,
  UPDATE_FAQ_SUCCESS,
  UPDATE_FAQ_FAIL,
  DELETE_FAQ,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_FAIL,
} from "./actionTypes";

export const resetFaqMessage = () => ({ type: RESET_FAQ_MESSAGE });

export const getFaq = (payload) => ({ type: GET_FAQ, payload });
export const getFaqSuccess = (payload) => ({ type: GET_FAQ_SUCCESS, payload });
export const getFaqFail = (error) => ({ type: GET_FAQ_FAIL, payload: error });

export const addFaq = (payload) => ({ type: ADD_FAQ, payload });
export const addFaqSuccess = (payload) => ({ type: ADD_FAQ_SUCCESS, payload });
export const addFaqFail = (error) => ({ type: ADD_FAQ_FAIL, payload: error });

export const updateFaq = (payload) => ({ type: UPDATE_FAQ, payload });
export const updateFaqSuccess = (payload) => ({
  type: UPDATE_FAQ_SUCCESS,
  payload,
});
export const updateFaqFail = (error) => ({
  type: UPDATE_FAQ_FAIL,
  payload: error,
});

export const deleteFaq = (payload) => ({ type: DELETE_FAQ, payload });
export const deleteFaqSuccess = (payload) => ({
  type: DELETE_FAQ_SUCCESS,
  payload,
});
export const deleteFaqFail = (error) => ({
  type: DELETE_FAQ_FAIL,
  payload: error,
});
